var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { isEmpty, isNil } from 'lodash-es';
import '../error/sds-error.lit';
/**
 * Base class for input elements.
 *
 * @fires sds.input.changed - Event is fired when change is detected.
 * @fires sds.input - Event is fired on input.
 * @fires sds.input.action - Event is fired when an action is performed.
 * @fires sds.input.cleared - Event is fired when the input is cleared.
 *
 */
let SdsNumberInputBase = (() => {
    var _a, _SdsNumberInputBase_value_accessor_storage, _SdsNumberInputBase_placeholder_accessor_storage, _SdsNumberInputBase_hint_accessor_storage, _SdsNumberInputBase_action_accessor_storage, _SdsNumberInputBase_hasClear_accessor_storage, _SdsNumberInputBase_minLength_accessor_storage, _SdsNumberInputBase_maxLength_accessor_storage, _SdsNumberInputBase_withToolbar_accessor_storage, _SdsNumberInputBase_focused_accessor_storage, _SdsNumberInputBase_buttonFocused_accessor_storage, _SdsNumberInputBase_readonly_accessor_storage, _SdsNumberInputBase_disabled_accessor_storage, _SdsNumberInputBase_invalid_accessor_storage, _SdsNumberInputBase_required_accessor_storage, _SdsNumberInputBase_errorMessage_accessor_storage, _SdsNumberInputBase_ariaLabel_accessor_storage, _SdsNumberInputBase_formControlLabel_accessor_storage, _SdsNumberInputBase_formControlHandlesError_accessor_storage, _SdsNumberInputBase_isNumberInput_accessor_storage, _SdsNumberInputBase_isExpanded_accessor_storage, _SdsNumberInputBase_isSelect_accessor_storage;
    let _classSuper = LitElement;
    let _value_decorators;
    let _value_initializers = [];
    let _value_extraInitializers = [];
    let _placeholder_decorators;
    let _placeholder_initializers = [];
    let _placeholder_extraInitializers = [];
    let _hint_decorators;
    let _hint_initializers = [];
    let _hint_extraInitializers = [];
    let _action_decorators;
    let _action_initializers = [];
    let _action_extraInitializers = [];
    let _hasClear_decorators;
    let _hasClear_initializers = [];
    let _hasClear_extraInitializers = [];
    let _minLength_decorators;
    let _minLength_initializers = [];
    let _minLength_extraInitializers = [];
    let _maxLength_decorators;
    let _maxLength_initializers = [];
    let _maxLength_extraInitializers = [];
    let _withToolbar_decorators;
    let _withToolbar_initializers = [];
    let _withToolbar_extraInitializers = [];
    let _focused_decorators;
    let _focused_initializers = [];
    let _focused_extraInitializers = [];
    let _buttonFocused_decorators;
    let _buttonFocused_initializers = [];
    let _buttonFocused_extraInitializers = [];
    let _readonly_decorators;
    let _readonly_initializers = [];
    let _readonly_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _required_decorators;
    let _required_initializers = [];
    let _required_extraInitializers = [];
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    let _ariaLabel_decorators;
    let _ariaLabel_initializers = [];
    let _ariaLabel_extraInitializers = [];
    let _formControlLabel_decorators;
    let _formControlLabel_initializers = [];
    let _formControlLabel_extraInitializers = [];
    let _formControlHandlesError_decorators;
    let _formControlHandlesError_initializers = [];
    let _formControlHandlesError_extraInitializers = [];
    let _isNumberInput_decorators;
    let _isNumberInput_initializers = [];
    let _isNumberInput_extraInitializers = [];
    let _isExpanded_decorators;
    let _isExpanded_initializers = [];
    let _isExpanded_extraInitializers = [];
    return _a = class SdsNumberInputBase extends _classSuper {
            constructor() {
                super(...arguments);
                _SdsNumberInputBase_value_accessor_storage.set(this, __runInitializers(this, _value_initializers, void 0));
                _SdsNumberInputBase_placeholder_accessor_storage.set(this, (__runInitializers(this, _value_extraInitializers), __runInitializers(this, _placeholder_initializers, '')));
                _SdsNumberInputBase_hint_accessor_storage.set(this, (__runInitializers(this, _placeholder_extraInitializers), __runInitializers(this, _hint_initializers, '')));
                _SdsNumberInputBase_action_accessor_storage.set(this, (__runInitializers(this, _hint_extraInitializers), __runInitializers(this, _action_initializers, '')));
                _SdsNumberInputBase_hasClear_accessor_storage.set(this, (__runInitializers(this, _action_extraInitializers), __runInitializers(this, _hasClear_initializers, true)));
                _SdsNumberInputBase_minLength_accessor_storage.set(this, (__runInitializers(this, _hasClear_extraInitializers), __runInitializers(this, _minLength_initializers, void 0)));
                _SdsNumberInputBase_maxLength_accessor_storage.set(this, (__runInitializers(this, _minLength_extraInitializers), __runInitializers(this, _maxLength_initializers, void 0)));
                _SdsNumberInputBase_withToolbar_accessor_storage.set(this, (__runInitializers(this, _maxLength_extraInitializers), __runInitializers(this, _withToolbar_initializers, false)));
                _SdsNumberInputBase_focused_accessor_storage.set(this, (__runInitializers(this, _withToolbar_extraInitializers), __runInitializers(this, _focused_initializers, false)));
                _SdsNumberInputBase_buttonFocused_accessor_storage.set(this, (__runInitializers(this, _focused_extraInitializers), __runInitializers(this, _buttonFocused_initializers, false)));
                _SdsNumberInputBase_readonly_accessor_storage.set(this, (__runInitializers(this, _buttonFocused_extraInitializers), __runInitializers(this, _readonly_initializers, false)));
                _SdsNumberInputBase_disabled_accessor_storage.set(this, (__runInitializers(this, _readonly_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
                _SdsNumberInputBase_invalid_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
                _SdsNumberInputBase_required_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _required_initializers, false)));
                _SdsNumberInputBase_errorMessage_accessor_storage.set(this, (__runInitializers(this, _required_extraInitializers), __runInitializers(this, _errorMessage_initializers, '')));
                this.unique = (__runInitializers(this, _errorMessage_extraInitializers), Math.random().toString(36).slice(2));
                _SdsNumberInputBase_ariaLabel_accessor_storage.set(this, __runInitializers(this, _ariaLabel_initializers, void 0));
                _SdsNumberInputBase_formControlLabel_accessor_storage.set(this, (__runInitializers(this, _ariaLabel_extraInitializers), __runInitializers(this, _formControlLabel_initializers, '')));
                _SdsNumberInputBase_formControlHandlesError_accessor_storage.set(this, (__runInitializers(this, _formControlLabel_extraInitializers), __runInitializers(this, _formControlHandlesError_initializers, false)));
                _SdsNumberInputBase_isNumberInput_accessor_storage.set(this, (__runInitializers(this, _formControlHandlesError_extraInitializers), __runInitializers(this, _isNumberInput_initializers, false)));
                _SdsNumberInputBase_isExpanded_accessor_storage.set(this, (__runInitializers(this, _isNumberInput_extraInitializers), __runInitializers(this, _isExpanded_initializers, false)));
                _SdsNumberInputBase_isSelect_accessor_storage.set(this, (__runInitializers(this, _isExpanded_extraInitializers), false));
            }
            /**
             * Current value of the input.
             * @attr
             */
            get value() { return __classPrivateFieldGet(this, _SdsNumberInputBase_value_accessor_storage, "f"); }
            set value(value) { __classPrivateFieldSet(this, _SdsNumberInputBase_value_accessor_storage, value, "f"); }
            /**
             * Placeholder text shown when the input is empty.
             * @attr
             */
            get placeholder() { return __classPrivateFieldGet(this, _SdsNumberInputBase_placeholder_accessor_storage, "f"); }
            set placeholder(value) { __classPrivateFieldSet(this, _SdsNumberInputBase_placeholder_accessor_storage, value, "f"); }
            /**
             * Supporting hint text shown below the control.
             * @attr
             */
            get hint() { return __classPrivateFieldGet(this, _SdsNumberInputBase_hint_accessor_storage, "f"); }
            set hint(value) { __classPrivateFieldSet(this, _SdsNumberInputBase_hint_accessor_storage, value, "f"); }
            /**
             * Name of the trailing action icon.
             * @attr
             */
            get action() { return __classPrivateFieldGet(this, _SdsNumberInputBase_action_accessor_storage, "f"); }
            set action(value) { __classPrivateFieldSet(this, _SdsNumberInputBase_action_accessor_storage, value, "f"); }
            /**
             * Enables the clear button when true.
             * @attr has-clear
             */
            get hasClear() { return __classPrivateFieldGet(this, _SdsNumberInputBase_hasClear_accessor_storage, "f"); }
            set hasClear(value) { __classPrivateFieldSet(this, _SdsNumberInputBase_hasClear_accessor_storage, value, "f"); }
            /**
             * Minimum number of characters required.
             * @attr
             */
            get minLength() { return __classPrivateFieldGet(this, _SdsNumberInputBase_minLength_accessor_storage, "f"); }
            set minLength(value) { __classPrivateFieldSet(this, _SdsNumberInputBase_minLength_accessor_storage, value, "f"); }
            /**
             * Maximum number of characters allowed.
             * @attr
             */
            get maxLength() { return __classPrivateFieldGet(this, _SdsNumberInputBase_maxLength_accessor_storage, "f"); }
            set maxLength(value) { __classPrivateFieldSet(this, _SdsNumberInputBase_maxLength_accessor_storage, value, "f"); }
            /**
             * Enables toolbar rendering for controls that support it.
             * @attr with-toolbar
             */
            get withToolbar() { return __classPrivateFieldGet(this, _SdsNumberInputBase_withToolbar_accessor_storage, "f"); }
            set withToolbar(value) { __classPrivateFieldSet(this, _SdsNumberInputBase_withToolbar_accessor_storage, value, "f"); }
            /**
             * True when the input itself is focused.
             * @attr
             */
            get focused() { return __classPrivateFieldGet(this, _SdsNumberInputBase_focused_accessor_storage, "f"); }
            set focused(value) { __classPrivateFieldSet(this, _SdsNumberInputBase_focused_accessor_storage, value, "f"); }
            /**
             * True when an action button inside the control is focused.
             * @attr
             */
            get buttonFocused() { return __classPrivateFieldGet(this, _SdsNumberInputBase_buttonFocused_accessor_storage, "f"); }
            set buttonFocused(value) { __classPrivateFieldSet(this, _SdsNumberInputBase_buttonFocused_accessor_storage, value, "f"); }
            /**
             * Prevents user edits while keeping the control focusable.
             * @attr
             */
            get readonly() { return __classPrivateFieldGet(this, _SdsNumberInputBase_readonly_accessor_storage, "f"); }
            set readonly(value) { __classPrivateFieldSet(this, _SdsNumberInputBase_readonly_accessor_storage, value, "f"); }
            /**
             * Disables user interaction with the control.
             * @attr
             */
            get disabled() { return __classPrivateFieldGet(this, _SdsNumberInputBase_disabled_accessor_storage, "f"); }
            set disabled(value) { __classPrivateFieldSet(this, _SdsNumberInputBase_disabled_accessor_storage, value, "f"); }
            /**
             * Marks the control as invalid.
             * @attr
             */
            get invalid() { return __classPrivateFieldGet(this, _SdsNumberInputBase_invalid_accessor_storage, "f"); }
            set invalid(value) { __classPrivateFieldSet(this, _SdsNumberInputBase_invalid_accessor_storage, value, "f"); }
            /**
             * Marks the control as required for accessibility semantics.
             * @attr
             */
            get required() { return __classPrivateFieldGet(this, _SdsNumberInputBase_required_accessor_storage, "f"); }
            set required(value) { __classPrivateFieldSet(this, _SdsNumberInputBase_required_accessor_storage, value, "f"); }
            /**
             * Validation error message shown below the control.
             * @attr error-message
             */
            get errorMessage() { return __classPrivateFieldGet(this, _SdsNumberInputBase_errorMessage_accessor_storage, "f"); }
            set errorMessage(value) { __classPrivateFieldSet(this, _SdsNumberInputBase_errorMessage_accessor_storage, value, "f"); }
            /**
             * Accessible name passed to the native input element.
             * Property-only (not reflected to an HTML attribute on the host).
             */
            get ariaLabel() { return __classPrivateFieldGet(this, _SdsNumberInputBase_ariaLabel_accessor_storage, "f"); }
            set ariaLabel(value) { __classPrivateFieldSet(this, _SdsNumberInputBase_ariaLabel_accessor_storage, value, "f"); }
            /**
             * Label value provided by `sds-form-control`.
             * Property-only (not reflected to an HTML attribute on the host).
             */
            get formControlLabel() { return __classPrivateFieldGet(this, _SdsNumberInputBase_formControlLabel_accessor_storage, "f"); }
            set formControlLabel(value) { __classPrivateFieldSet(this, _SdsNumberInputBase_formControlLabel_accessor_storage, value, "f"); }
            /**
             * Set by sds-form-control when it is rendering the error itself.
             * Prevents the child from rendering a duplicate visual error.
             */
            get formControlHandlesError() { return __classPrivateFieldGet(this, _SdsNumberInputBase_formControlHandlesError_accessor_storage, "f"); }
            set formControlHandlesError(value) { __classPrivateFieldSet(this, _SdsNumberInputBase_formControlHandlesError_accessor_storage, value, "f"); }
            /**
             * Internal flag for numeric controls that expose spinbutton semantics.
             */
            get isNumberInput() { return __classPrivateFieldGet(this, _SdsNumberInputBase_isNumberInput_accessor_storage, "f"); }
            set isNumberInput(value) { __classPrivateFieldSet(this, _SdsNumberInputBase_isNumberInput_accessor_storage, value, "f"); }
            /**
             * True when the select popup is currently expanded/opened.
             * Set programmatically by select-style input components.
             */
            get isExpanded() { return __classPrivateFieldGet(this, _SdsNumberInputBase_isExpanded_accessor_storage, "f"); }
            set isExpanded(value) { __classPrivateFieldSet(this, _SdsNumberInputBase_isExpanded_accessor_storage, value, "f"); }
            /**
             * Internal mode flag for select/dropdown behavior.
             * Set programmatically by select-style input components.
             */
            get isSelect() { return __classPrivateFieldGet(this, _SdsNumberInputBase_isSelect_accessor_storage, "f"); }
            set isSelect(value) { __classPrivateFieldSet(this, _SdsNumberInputBase_isSelect_accessor_storage, value, "f"); }
            renderInput(type) {
                const hintId = this.hint ? `${this.unique}-hint` : undefined;
                const errorId = this.invalid && this.errorMessage && !this.formControlHandlesError
                    ? `${this.unique}-error`
                    : undefined;
                const ariaDescribedBy = [hintId, errorId].filter(Boolean).join(' ') || undefined;
                return html `
            <input
                id="${this.unique}"
                class="sds-input__element"
                part="sds-input-element"
                autocomplete="off"
                placeholder="${this.placeholder}"
                value="${this.value}"
                type="${type}"
                minlength="${ifDefined(this.minLength)}"
                maxlength="${ifDefined(this.maxLength)}"
                ?required="${this.required}"
                ?readonly="${this.readonly}"
                ?disabled="${this.disabled}"
                aria-disabled="${this.disabled ? 'true' : 'false'}"
                aria-label="${ifDefined(this.ariaLabel)}"
                aria-invalid="${ifDefined(this.invalid ? 'true' : undefined)}"
                aria-describedby="${ifDefined(ariaDescribedBy)}"
                role="${this.roleValue()}"
                aria-autocomplete="${ifDefined(this.isSelect ? 'list' : undefined)}"
                aria-haspopup="${ifDefined(this.isSelect ? 'listbox' : undefined)}"
                aria-expanded="${ifDefined(this.isSelect ? (this.isExpanded ? 'true' : 'false') : undefined)}"
                aria-valuenow="${ifDefined(this.getAriaValueNow())}"
                aria-valuemin="${ifDefined(this.getAriaValueMin())}"
                aria-valuemax="${ifDefined(this.getAriaValueMax())}"
                @input="${() => this.handleInput()}"
                @focus="${() => this.handleFocus()}"
                @blur="${() => this.handleBlur()}"
                @change="${() => this.handleChanged()}"
                @wheel="${(event) => this.handleWheel(event)}"
                @keydown="${(event) => this.handleKeyDown(event)}"
                @keyup="${(event) => this.handleKeyUp(event)}"
            />
        `;
            }
            willUpdate(changedProperties) {
                var _b;
                if (changedProperties.has('formControlLabel') ||
                    changedProperties.has('invalid') ||
                    changedProperties.has('errorMessage') ||
                    changedProperties.has('formControlHandlesError')) {
                    if ((_b = this.formControlLabel) === null || _b === void 0 ? void 0 : _b.trim()) {
                        // Embed the error in aria-label only when formControlHandlesError is true
                        // (form-control renders sds-error in its own shadow root — unreachable via
                        // aria-describedby). When false the child renders its own sds-error in the
                        // same shadow root, so aria-describedby covers it without duplication.
                        this.ariaLabel =
                            this.invalid && this.errorMessage && this.formControlHandlesError
                                ? `${this.formControlLabel}, ${this.errorMessage},`
                                : this.formControlLabel;
                    }
                }
            }
            renderClear() {
                if (this.showClear()) {
                    return html `
                <sds-button
                    library="system"
                    type="ghost"
                    icon="close_circle"
                    size="md"
                    aria-label="Clear value"
                    @focus="${() => {
                        this.handleActionFocus();
                    }}"
                    @blur="${() => this.handleActionBlur()}"
                    @click="${e => this.handleClear(e)}"
                ></sds-button>
            `;
                }
            }
            renderMessages() {
                if (this.hint || (this.errorMessage && this.invalid && !this.formControlHandlesError)) {
                    return html `
                <div class="sds-input__messages" part="sds-input-messages">
                    ${this.renderHint()} ${this.renderError()}
                </div>
            `;
                }
            }
            renderError() {
                if (this.errorMessage && this.invalid && !this.formControlHandlesError) {
                    return html `
                <sds-error id="${this.unique}-error" message="${this.errorMessage}"></sds-error>
            `;
                }
            }
            renderHint() {
                if (this.hint) {
                    return html ` <div id="${this.unique}-hint" class="sds-input__hint">${this.hint}</div> `;
                }
            }
            renderAction(actionIcon) {
                if (this.action) {
                    return html `
                <sds-button
                    type="tertiary"
                    icon="${actionIcon}"
                    size="md"
                    @focus="${() => {
                        this.handleActionFocus();
                    }}"
                    @blur="${() => this.handleActionBlur()}"
                    @click="${(e) => this.dispatchAction(e)}"
                ></sds-button>
            `;
                }
            }
            renderActionContainer() {
                if (this.action || this.showClear()) {
                    return html `
                <div class="sds-input__actions" part="sds-input-actions">
                    ${this.renderClear()} ${this.renderAction(this.action)}
                </div>
            `;
                }
            }
            /**
             * Root class names for the input shell (`sds-input`, modifiers). Subclasses may override to add modifiers.
             */
            getInputRootClassInfo() {
                return {
                    'sds-input': true,
                    'sds-input--focused': this.focused || this.buttonFocused,
                    'sds-input--disabled': this.disabled,
                    'sds-input--invalid': this.invalid,
                    'sds-input--has-action': this.action,
                    'sds-input--with-toolbar': this.withToolbar,
                    'sds-input--without-clear': !this.hasClear,
                };
            }
            getClasses() {
                return classMap(this.getInputRootClassInfo());
            }
            handleInput() {
                this.value = this.convertValue(this.getInput().value);
                this.requestUpdate('value', this.getInput().value);
                this.dispatchChange();
            }
            handleFocus() {
                this.focused = true;
            }
            handleActionFocus() {
                this.buttonFocused = true;
            }
            handleBlur() {
                this.focused = false;
            }
            handleActionBlur() {
                this.buttonFocused = false;
            }
            handleResize() { }
            showClear() {
                return !isNil(this.value) && !isEmpty(this.value) && !this.disabled && this.hasClear;
            }
            handleClear(event) {
                this.value = this.emptyValue();
                this.dispatchClear();
                this.focused = true;
                event === null || event === void 0 ? void 0 : event.stopPropagation();
            }
            handleChanged() {
                this.dispatchEvent(new CustomEvent(_a.CHANGE_EVENT, {
                    detail: { value: this.value },
                    bubbles: false,
                    composed: false,
                }));
                this.dispatchEvent(new CustomEvent(_a.NATIVE_CHANGE_EVENT, {
                    detail: { value: this.value },
                    bubbles: false,
                    composed: false,
                }));
            }
            updated(changedProperties) {
                if (changedProperties.has('focused') && this.focused) {
                    this.getInput().focus();
                    const type = this.getInput().type;
                    if (type === 'tel') {
                        this.getInput().select();
                    }
                }
                if (changedProperties.has('value')) {
                    this.getInput().value = this.valueToString(this.convertValue(this.value));
                }
            }
            addEventListener(type, listener, options) {
                super.addEventListener(type, listener, options);
            }
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            handleWheel(event) { }
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            handleKeyDown(event) { }
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            handleKeyUp(event) { }
            roleValue() {
                if (this.isNumberInput) {
                    return 'spinbutton';
                }
                return ifDefined(this.isSelect ? 'combobox' : undefined);
            }
            getAriaValueNow() {
                return undefined;
            }
            getAriaValueMin() {
                return undefined;
            }
            getAriaValueMax() {
                return undefined;
            }
            valueToString(value) {
                if (isNil(value)) {
                    return this.emptyValue().toString();
                }
                return value.toString();
            }
            dispatchChange() {
                this.dispatchEvent(new CustomEvent(_a.INPUT_EVENT, {
                    detail: { value: this.value },
                    bubbles: false,
                    composed: false,
                }));
                this.dispatchEvent(new CustomEvent(_a.NATIVE_INPUT_EVENT, {
                    detail: { value: this.value },
                    bubbles: false,
                    composed: false,
                }));
            }
            dispatchClear() {
                this.dispatchEvent(new CustomEvent(_a.TEXT_CLEARED, {
                    detail: { value: this.value },
                    bubbles: false,
                    composed: false,
                }));
            }
            dispatchAction(e) {
                this.dispatchEvent(new CustomEvent(_a.ACTION_EVENT));
                this.focused = false;
                this.buttonFocused = false;
                e.stopPropagation();
            }
            /**
             * Programmatically click the input element.
             */
            click() {
                this.getInput().focus();
                this.handleFocus();
                const clickEvent = new MouseEvent('click', {
                    bubbles: true,
                    composed: true,
                    cancelable: true,
                    view: window,
                });
                this.dispatchEvent(clickEvent);
            }
            /**
             * Programmatically focus the input element.
             */
            focus() {
                this.getInput().focus();
                this.handleFocus();
            }
            /**
             * Programmatically blur the input element.
             */
            blur() {
                this.getInput().blur();
                this.handleBlur();
            }
        },
        _SdsNumberInputBase_value_accessor_storage = new WeakMap(),
        _SdsNumberInputBase_placeholder_accessor_storage = new WeakMap(),
        _SdsNumberInputBase_hint_accessor_storage = new WeakMap(),
        _SdsNumberInputBase_action_accessor_storage = new WeakMap(),
        _SdsNumberInputBase_hasClear_accessor_storage = new WeakMap(),
        _SdsNumberInputBase_minLength_accessor_storage = new WeakMap(),
        _SdsNumberInputBase_maxLength_accessor_storage = new WeakMap(),
        _SdsNumberInputBase_withToolbar_accessor_storage = new WeakMap(),
        _SdsNumberInputBase_focused_accessor_storage = new WeakMap(),
        _SdsNumberInputBase_buttonFocused_accessor_storage = new WeakMap(),
        _SdsNumberInputBase_readonly_accessor_storage = new WeakMap(),
        _SdsNumberInputBase_disabled_accessor_storage = new WeakMap(),
        _SdsNumberInputBase_invalid_accessor_storage = new WeakMap(),
        _SdsNumberInputBase_required_accessor_storage = new WeakMap(),
        _SdsNumberInputBase_errorMessage_accessor_storage = new WeakMap(),
        _SdsNumberInputBase_ariaLabel_accessor_storage = new WeakMap(),
        _SdsNumberInputBase_formControlLabel_accessor_storage = new WeakMap(),
        _SdsNumberInputBase_formControlHandlesError_accessor_storage = new WeakMap(),
        _SdsNumberInputBase_isNumberInput_accessor_storage = new WeakMap(),
        _SdsNumberInputBase_isExpanded_accessor_storage = new WeakMap(),
        _SdsNumberInputBase_isSelect_accessor_storage = new WeakMap(),
        (() => {
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _value_decorators = [property({ type: String || Number, reflect: true })];
            _placeholder_decorators = [property({ type: String })];
            _hint_decorators = [property({ type: String })];
            _action_decorators = [property({ type: String })];
            _hasClear_decorators = [property({
                    type: Boolean,
                    attribute: 'has-clear',
                    reflect: true,
                    converter: (value) => value !== 'false',
                })];
            _minLength_decorators = [property({ attribute: 'minlength', type: Number })];
            _maxLength_decorators = [property({ attribute: 'maxlength', type: Number })];
            _withToolbar_decorators = [property({ type: Boolean, attribute: 'with-toolbar' })];
            _focused_decorators = [property({ type: Boolean, reflect: true })];
            _buttonFocused_decorators = [property({ type: Boolean })];
            _readonly_decorators = [property({ type: Boolean })];
            _disabled_decorators = [property({ type: Boolean })];
            _invalid_decorators = [property({ type: Boolean, reflect: true })];
            _required_decorators = [property({ type: Boolean, reflect: true })];
            _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
            _ariaLabel_decorators = [property({ attribute: false })];
            _formControlLabel_decorators = [property({ attribute: false })];
            _formControlHandlesError_decorators = [property({ attribute: false })];
            _isNumberInput_decorators = [property({ attribute: false })];
            _isExpanded_decorators = [property({ type: Boolean })];
            __esDecorate(_a, null, _value_decorators, { kind: "accessor", name: "value", static: false, private: false, access: { has: obj => "value" in obj, get: obj => obj.value, set: (obj, value) => { obj.value = value; } }, metadata: _metadata }, _value_initializers, _value_extraInitializers);
            __esDecorate(_a, null, _placeholder_decorators, { kind: "accessor", name: "placeholder", static: false, private: false, access: { has: obj => "placeholder" in obj, get: obj => obj.placeholder, set: (obj, value) => { obj.placeholder = value; } }, metadata: _metadata }, _placeholder_initializers, _placeholder_extraInitializers);
            __esDecorate(_a, null, _hint_decorators, { kind: "accessor", name: "hint", static: false, private: false, access: { has: obj => "hint" in obj, get: obj => obj.hint, set: (obj, value) => { obj.hint = value; } }, metadata: _metadata }, _hint_initializers, _hint_extraInitializers);
            __esDecorate(_a, null, _action_decorators, { kind: "accessor", name: "action", static: false, private: false, access: { has: obj => "action" in obj, get: obj => obj.action, set: (obj, value) => { obj.action = value; } }, metadata: _metadata }, _action_initializers, _action_extraInitializers);
            __esDecorate(_a, null, _hasClear_decorators, { kind: "accessor", name: "hasClear", static: false, private: false, access: { has: obj => "hasClear" in obj, get: obj => obj.hasClear, set: (obj, value) => { obj.hasClear = value; } }, metadata: _metadata }, _hasClear_initializers, _hasClear_extraInitializers);
            __esDecorate(_a, null, _minLength_decorators, { kind: "accessor", name: "minLength", static: false, private: false, access: { has: obj => "minLength" in obj, get: obj => obj.minLength, set: (obj, value) => { obj.minLength = value; } }, metadata: _metadata }, _minLength_initializers, _minLength_extraInitializers);
            __esDecorate(_a, null, _maxLength_decorators, { kind: "accessor", name: "maxLength", static: false, private: false, access: { has: obj => "maxLength" in obj, get: obj => obj.maxLength, set: (obj, value) => { obj.maxLength = value; } }, metadata: _metadata }, _maxLength_initializers, _maxLength_extraInitializers);
            __esDecorate(_a, null, _withToolbar_decorators, { kind: "accessor", name: "withToolbar", static: false, private: false, access: { has: obj => "withToolbar" in obj, get: obj => obj.withToolbar, set: (obj, value) => { obj.withToolbar = value; } }, metadata: _metadata }, _withToolbar_initializers, _withToolbar_extraInitializers);
            __esDecorate(_a, null, _focused_decorators, { kind: "accessor", name: "focused", static: false, private: false, access: { has: obj => "focused" in obj, get: obj => obj.focused, set: (obj, value) => { obj.focused = value; } }, metadata: _metadata }, _focused_initializers, _focused_extraInitializers);
            __esDecorate(_a, null, _buttonFocused_decorators, { kind: "accessor", name: "buttonFocused", static: false, private: false, access: { has: obj => "buttonFocused" in obj, get: obj => obj.buttonFocused, set: (obj, value) => { obj.buttonFocused = value; } }, metadata: _metadata }, _buttonFocused_initializers, _buttonFocused_extraInitializers);
            __esDecorate(_a, null, _readonly_decorators, { kind: "accessor", name: "readonly", static: false, private: false, access: { has: obj => "readonly" in obj, get: obj => obj.readonly, set: (obj, value) => { obj.readonly = value; } }, metadata: _metadata }, _readonly_initializers, _readonly_extraInitializers);
            __esDecorate(_a, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
            __esDecorate(_a, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
            __esDecorate(_a, null, _required_decorators, { kind: "accessor", name: "required", static: false, private: false, access: { has: obj => "required" in obj, get: obj => obj.required, set: (obj, value) => { obj.required = value; } }, metadata: _metadata }, _required_initializers, _required_extraInitializers);
            __esDecorate(_a, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
            __esDecorate(_a, null, _ariaLabel_decorators, { kind: "accessor", name: "ariaLabel", static: false, private: false, access: { has: obj => "ariaLabel" in obj, get: obj => obj.ariaLabel, set: (obj, value) => { obj.ariaLabel = value; } }, metadata: _metadata }, _ariaLabel_initializers, _ariaLabel_extraInitializers);
            __esDecorate(_a, null, _formControlLabel_decorators, { kind: "accessor", name: "formControlLabel", static: false, private: false, access: { has: obj => "formControlLabel" in obj, get: obj => obj.formControlLabel, set: (obj, value) => { obj.formControlLabel = value; } }, metadata: _metadata }, _formControlLabel_initializers, _formControlLabel_extraInitializers);
            __esDecorate(_a, null, _formControlHandlesError_decorators, { kind: "accessor", name: "formControlHandlesError", static: false, private: false, access: { has: obj => "formControlHandlesError" in obj, get: obj => obj.formControlHandlesError, set: (obj, value) => { obj.formControlHandlesError = value; } }, metadata: _metadata }, _formControlHandlesError_initializers, _formControlHandlesError_extraInitializers);
            __esDecorate(_a, null, _isNumberInput_decorators, { kind: "accessor", name: "isNumberInput", static: false, private: false, access: { has: obj => "isNumberInput" in obj, get: obj => obj.isNumberInput, set: (obj, value) => { obj.isNumberInput = value; } }, metadata: _metadata }, _isNumberInput_initializers, _isNumberInput_extraInitializers);
            __esDecorate(_a, null, _isExpanded_decorators, { kind: "accessor", name: "isExpanded", static: false, private: false, access: { has: obj => "isExpanded" in obj, get: obj => obj.isExpanded, set: (obj, value) => { obj.isExpanded = value; } }, metadata: _metadata }, _isExpanded_initializers, _isExpanded_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a.CHANGE_EVENT = 'sds.input.changed',
        _a.INPUT_EVENT = 'sds.input',
        _a.ACTION_EVENT = 'sds.input.action',
        _a.TEXT_CLEARED = 'sds.input.cleared',
        _a.NATIVE_INPUT_EVENT = 'input',
        _a.NATIVE_CHANGE_EVENT = 'change',
        _a;
})();
export { SdsNumberInputBase };
